<ng-container *ngIf="options && optionsInput">
    <div class="upload-page">
        <!-- Zone d'import : toute la zone est cliquable (la directive *ngxInputFile l'enveloppe d'un <label>). -->
        <div class="upload-dropzone" [ngxDragAndDrop]="options" *ngxInputFile="optionsInput">
            <div class="upload-dropzone-icon">
                <fa-icon [icon]="faUpload"></fa-icon>
            </div>
            <h3 class="upload-dropzone-title">{{ 'upload.dropTitle' | translate }}</h3>
            <p class="upload-dropzone-subtitle">{{ 'upload.dropSubtitle' | translate }}</p>
            <p class="upload-dropzone-meta" *ngIf="acceptedFormats.length">
                {{ 'upload.acceptedFormats' | translate }} {{ acceptedFormats.join(', ') }}
                <span class="upload-dropzone-sep">&bull;</span>
                {{ 'upload.maxSize' | translate: { size: maxFileSizeLabel } }}
            </p>
            <!-- <span> stylé en bouton : un vrai <button> intercepterait le clic du <label> parent. -->
            <span class="btn btn-primary upload-select-btn">
                <fa-icon [icon]="faFolderOpen" class="mr-2"></fa-icon>{{ 'upload.selectFiles' | translate }}
            </span>
        </div>

        <!-- File d'attente -->
        <div class="card upload-queue">
            <div class="card-header upload-queue-header">
                <span class="upload-queue-title">{{ 'upload.queue' | translate }}</span>
                <span class="upload-queue-count">{{ uploader.queue.length }}</span>
            </div>

            <div class="table-responsive" *ngIf="uploader.queue.length > 0">
                <table class="table upload-queue-table m-0">
                    <thead>
                        <tr>
                            <th>{{ 'upload.name' | translate }}</th>
                            <th class="text-nowrap">{{ 'upload.size' | translate }}</th>
                            <th>{{ 'upload.status' | translate }}</th>
                            <th class="upload-col-progress">{{ 'upload.progress' | translate }}</th>
                            <th class="text-right">{{ 'general.action' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let itemFile of uploader.queue" [ngClass]="{ 'table-success': itemFile.isSuccess, 'table-danger': itemFile.isError }">
                            <td>
                                <div class="d-flex align-items-center">
                                    <input type="text" class="form-control form-control-sm upload-name-input" [(ngModel)]="itemFile.displayName"
                                        [disabled]="itemFile.isSuccess || itemFile.uploadInProgress" [attr.aria-label]="'upload.name' | translate" />
                                    <span class="ml-1 text-muted text-nowrap">{{ itemFile.extension }}</span>
                                </div>
                            </td>
                            <td class="text-nowrap">{{ itemFile.file.size / 1024 / 1024 | number: '1.0-2' }} MB</td>
                            <td>
                                <span class="upload-status-badge" [ngClass]="'is-' + fileStatus(itemFile)">
                                    {{ 'upload.status' + (fileStatus(itemFile) | titlecase) | translate }}
                                </span>
                            </td>
                            <td class="upload-col-progress">
                                <ngb-progressbar type="success" showValue="true" [striped]="true" [animated]="true" [value]="itemFile.progress"></ngb-progressbar>
                            </td>
                            <td class="text-right">
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="itemFile.remove()"
                                    [disabled]="itemFile.isSuccess || itemFile.uploadInProgress" [ngbTooltip]="'general.remove' | translate" container="body" placement="left">
                                    <fa-icon [icon]="faTrashAlt"></fa-icon>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- État vide illustré (bannette) -->
            <div *ngIf="uploader.queue.length === 0" class="upload-empty text-center">
                <svg class="upload-empty-illustration" width="74" height="74" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M20 8 L21.1 10.9 L24 12 L21.1 13.1 L20 16 L18.9 13.1 L16 12 L18.9 10.9 Z" fill="#9fdbce"/>
                    <path d="M44 6 L44.8 8.2 L47 9 L44.8 9.8 L44 12 L43.2 9.8 L41 9 L43.2 8.2 Z" fill="#cdebe3"/>
                    <circle cx="37" cy="15" r="1.4" fill="#cdebe3"/>
                    <path d="M11 33 L18 19 H46 L53 33 V45 a4 4 0 0 1 -4 4 H15 a4 4 0 0 1 -4 -4 Z"
                          fill="#e2f3ef" stroke="#4eb8aa" stroke-width="2.2" stroke-linejoin="round"/>
                    <path d="M11 33 H23 L26 38 H38 L41 33 H53"
                          fill="none" stroke="#4eb8aa" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round"/>
                </svg>
                <div class="upload-empty-title font-weight-bold">{{ 'upload.emptyTitle' | translate }}</div>
                <div class="upload-empty-subtitle">{{ 'upload.emptySubtitle' | translate }}</div>
            </div>

            <!-- Options pictos / claro (ACL) -->
            <div class="upload-options" *ngIf="acl.MAESTRO_DAM_PICTO_CREATE === 1 || claroAvailable">
                <div class="upload-option" *ngIf="acl.MAESTRO_DAM_PICTO_CREATE === 1">
                    <label class="font-weight-bold mb-0 mr-2" for="picto">{{ 'upload.picto' | translate }}</label>
                    <label class="switch switch-pill switch-primary mb-0">
                        <input id="picto" type="checkbox" class="switch-input">
                        <span class="switch-slider"></span>
                    </label>
                </div>
                <div class="upload-option" *ngIf="claroAvailable">
                    <label class="font-weight-bold mb-0 mr-2" for="claro">{{ 'upload.claro' | translate }}</label>
                    <label class="switch switch-pill switch-primary mb-0">
                        <input id="claro" type="checkbox" class="switch-input">
                        <span class="switch-slider"></span>
                    </label>
                </div>
            </div>

            <!-- Pied : actions -->
            <div class="upload-footer">
                <button [disabled]="uploader.queue.length === 0 || disabled" type="button" class="btn btn-primary" (click)="upload()">
                    <fa-icon [icon]="faDownload" class="mr-2"></fa-icon>{{ 'upload.all' | translate }}
                </button>
                <a *ngIf="!modal" class="btn btn-outline-primary" [routerLink]="['/' + routes.dam.base]">
                    <fa-icon [icon]="faArrowLeft" class="mr-2"></fa-icon>{{ 'upload.backToDam' | translate }}
                </a>
                <button *ngIf="modal" type="button" class="btn btn-outline-primary" (click)="closeRequested.emit()">
                    <fa-icon [icon]="faArrowLeft" class="mr-2"></fa-icon>{{ 'general.close' | translate }}
                </button>
            </div>
        </div>

        <!-- Bannière conseil -->
        <div class="upload-tip">
            <fa-icon [icon]="faInfoCircle" class="upload-tip-icon mr-2"></fa-icon>
            <span><strong>{{ 'upload.tipLabel' | translate }} :</strong> {{ 'upload.tip' | translate }}</span>
        </div>
    </div>
</ng-container>
